<template>
  <div
    class="button inline-flex items-center focus:outline-none h-46px"
    :is="href ? 'a' : 'button'"
    :href="!!href ? href : false"
    :type="!!!href ? type : false"
    :class="{ 'flex-row-reverse': reversed, 'is-loading': loading, 'rounded-full' : rounded }"
    :disabled="disabled"
    @focus="onFocus"
    @mouseenter="onMouseenter"
    @mouseleave="onMouseleave"
    @click="$emit('click')"
  >
    <slot name="button">
      <div
        ref="button"
        tabindex="0"
        class="button rounded-full inline-flex items-center justify-center"
        :class="[buttonClasses, getFieldClasses]"
      >
        <span class="icon" :class="getIcon" />
      </div>
    </slot>
    <div v-if="$slots.default" :class="{ 'mr-22px': !reversed, 'ml-22px': reversed }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "button"
    },
    rounded: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "add"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    reversed: {
      type: Boolean,
      default: false
    },
    buttonClasses: [String, Array]
  },
  data() {
    return {
      hovered: false
    };
  },
  computed: {
    getFieldClasses() {
      return {
        "pl-18px pr-2 text-lg": !this.xsmall && !this.small && !this.large,
        "h-6 w-6 text-sm": this.xsmall,
        "h-8 w-8": this.small,
        "h-12 w-12 text-xl": this.large,
        "is-hovered": this.hovered
      };
    },
    getIcon() {
      return `icon-${this.icon}`;
    }
  },
  methods: {
    onFocus() {
      if (this.$refs.button) {
        this.$refs.button.focus();
      }
    },
    onMouseenter() {
      this.hovered = true;
    },
    onMouseleave() {
      this.hovered = false;
    }
  }
};
</script>

<style scoped>
@keyframes fade {
  0%,
  100% {
    @apply opacity-75;
  }
  50% {
    @apply opacity-25;
  }
}
.button.is-loading {
  animation: fade 2s infinite;
  @apply pointer-events-none;
}
</style>
